import gql from "graphql-tag";

const response = `
    id
    title
    slug
    image
    isLastOrdered
    optionGroups{
      groupId
      id
      options{
        productId
        productTitle
        quantity
        priority
        groupId
        price
      }
    }
`;

export const PRESETS_QUERY = gql`
  query PRESETS($productId: Int!, $storeId: Int, $includePersonalizedPreset: Boolean!) {
    presets(productId: $productId, storeId: $storeId, includePersonalizedPreset: $includePersonalizedPreset) {
        ${response}
    }
  }
`;
